import updateVariantRatingStatusAction from 'modules/product/redux/actions/update-variant-rating-status'
import updateProductRatingStatusAction from 'modules/product/redux/actions/update-product-rating-status'
import updateCurrentToastAction from 'modules/toast/redux/actions/update-current'

const SAMPLE_RATED = 'Sample rated'
/**
 * @param variantId
 * @param productId
 * @param rating
 * @returns {(function(*): Promise<void>)|*}
 */
export default function toggleProductVariantRatingStatusAction ({
  variantId,
  productId,
  rating
}) {
  return async (dispatch) => {
    /**
     * update the variant rating status
     */

    await dispatch(
      updateVariantRatingStatusAction({
        variantId,
        rating
      })
    )

    /**
     * update the product rating status
     */
    await dispatch(
      updateProductRatingStatusAction({
        productId,
        rating
      })
    )

    /**
     * show toast
     */
    dispatch(updateCurrentToastAction(SAMPLE_RATED))
  }
}
